<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2a">
<p class="author"><span class="bold">By the same author</span></p>
<p class="aut_"><em class="italic">Flight Unlimited</em> (with Eric Müller) Müller &amp; Carson, London, 1983.</p>
<p class="aut_"><em class="italic">Flight Unlimited ’95</em> (with Eric Müller) Carson, Morningside, 1995.</p>
<p class="aut_"><em class="italic">Flight Fantastic: The Illustrated History of Aerobatics</em>, Foulis/Haynes, Sparkford, 1986.</p>
<p class="aut_"><em class="italic">Welgevonden: Wilderness in the Waterberg</em>, Lapalala, Johannesburg, 1995.</p>
<p class="aut_"><em class="italic">Jeff Beck: Crazy Fingers</em>, Backbeat Books, San Francisco, 2001</p>
<p class="aut_"><em class="italic">Richard III: The Maligned King</em>, The History Press, Stroud, 2008 and 2013.</p>
<p class="aut_"><em class="italic">Richard III: A Small Guide to the Great Debate</em>, Imprimis, Norwich, 2013.</p>
<p class="aut_"><em class="italic">Finding Richard III: The Official Account of the Retrieval and Reburial Project</em> (Ed.) (with J. Ashdown-Hill, D. Johnson, W. Johnson and P.J. Langley), Imprimis, Norwich, 2014.</p>
<p class="aut_"><em class="italic">Richard Duke of Gloucester as Lord Protector and High Constable of England</em>, Imprimis, Norwich, 2015.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_About_author.vue?6d7cb3e1